<template>
  <div :class="`${home ? 'avatar-home' : ''}`">
    <PvAvatar
      :image="config.avatarPath"
      :size="avatarSize"
      shape="circle"
    />
  </div>
</template>

<script>
import Avatar from 'primevue/avatar'

export default {
  name: 'Avatar',
  components: {
    PvAvatar: Avatar
  },
  data: function () {
    return {
      config: this.getConfig().config
    }
  },
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    home: {
      type: String,
      default: ''
    }
  },
  computed: {
    // PrimeVue Avatar 只接受 'normal' | 'large' | 'xlarge',
    // 原项目 Home 传 size="300" 是为了配合 CSS 放大,这里映射到 large
    // 首页的大头像靠 .avatar-home CSS 控制
    avatarSize: function () {
      if (this.home) return 'xlarge'
      if (this.size === 'large' || this.size === 'xlarge') return this.size
      return 'normal'
    }
  }
}
</script>

<style scoped>
.avatar-home :deep(.p-avatar) {
  min-width: 200px !important;
  min-height: 200px !important;
  width: 200px !important;
  height: 200px !important;
}

.avatar-home :deep(.p-avatar img) {
  width: 100% !important;
  height: 100% !important;
}
</style>
